import { FallbackCard } from '@components/atoms/FallbackCard/FallbackCard';
import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import { Carousel } from '@components/molecules/Carousel/Carousel';
import { GrowingElement } from '@components/molecules/GrowingElement/GrowingElement';
import { useFathomTracker } from '@src/lib/hooks/useFathomTracker';
import { Image } from '@vgn-medien-holding/vgn-fe-components';
import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { twMerge } from 'tailwind-merge';

export const PageContentElementTvmCustomLaneAd = (element) => {
  const [lastScroll, setLastScroll] = useState(0);
  const { trackEvent } = useFathomTracker();

  const [trackingRef, isInView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (isInView) {
      trackEvent(`Ad Lane View: ${element?.title}`);
    }
  }, [isInView, trackEvent, element?.title]);

  if (!element?.customItems) return null;
  return (
    <div className="relative pl-4 sm:pl-8 lg:pl-16" ref={trackingRef}>
      <div className="mb-3 flex content-center items-center gap-x-4">
        {!!element?.favicon?.url && (
          <Image
            src={element?.favicon?.url}
            alt={element?.favicon?.title}
            width={300}
            height={300}
            copyright={element?.favicon?.copyright_text}
            imageMode="cover"
            classProps={{ container: 'size-14 rounded-full overflow-hidden flex-none' }}
          />
        )}
        <div>
          <ShowAllTitle
            title={element.title}
            onClick={() => trackEvent(`Ad Lane Click: ${element?.title}`)}
            linkText={element?.link_text}
            link={element.title_link}
            newTab={element?.title_link_blank_window}
            classProps={{ title: 'mb-1' }}
          />
          <div className="text-base text-foreground/60 leading-none">Werbung</div>
        </div>
      </div>
      <section className="space-y-32">
        <Carousel
          onScrollComplete={() => {
            setLastScroll((prev) => prev + 1);
          }}
        >
          {element?.customItems?.map((item) => (
            <GrowingElement
              lastScroll={lastScroll}
              link={item?.link}
              openInTab
              key={item?.id}
              onClick={() => trackEvent(`Ad Lane Click: ${element?.title}`)}
              topSlot={
                item?.image?.url ? (
                  <Image
                    src={item?.image.url}
                    alt={item?.title}
                    width={350}
                    height={200}
                    copyright=""
                    imageMode="cover"
                    classProps={{
                      container: twMerge('absolute inset-0 rounded-t-lg overflow-hidden'),
                    }}
                  />
                ) : (
                  <FallbackCard classProps={{ root: 'overflow-hidden rounded-t-lg' }} />
                )
              }
              bottomSlot={
                <div className="grid w-full gap-1 p-2 transition-spacings duration-150 canhover:group-hover:px-4 canhover:group-hover:pt-3">
                  <div className="font-herokid font-medium">{item?.title}</div>
                  <div className="label-sm">{item?.subheadline}</div>
                </div>
              }
            />
          ))}
        </Carousel>
      </section>
    </div>
  );
};

export default PageContentElementTvmCustomLaneAd;
